/** @jsx jsx */
import React, { useState } from 'react'
import { jsx } from 'theme-ui'
import { css } from '@emotion/react'
import { shuffle, take, times, get, findIndex } from 'lodash'
import { mapRange, lerp } from 'canvas-sketch-util/math'

import Button, { randomGradColor } from '../button'
import Paragraph from '../paragraph'
import Card from '../card'

import { fillArea, floodBgImage } from '../../styles/css'
import {
  Cont,
  FlexCol,
  FlexColEmpty,
  FlexCols,
  HStack,
  VStack,
} from '../../styles/els'
import { renderHTML, resolveButtons, formatImage } from '../../lib/helpers'
import { ImageInline } from '../image'

const FlexButtons = (props) => {
  const { label, buttons, activeIndex, small } = props

  return (
    <div
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: ['wrap', null, 'nowrap'],
        flexDirection: small ? 'column' : 'row',
      }}
    >
      {label ? (
        <div
          sx={{
            variant: small ? 'text.regular_19' : 'text.regular_28',
            pt: '8px',
            pr: [0, null, 7],
            pb: [5, null, small ? 2 : 0],
            color: 'b6',
            width: ['100%', null, 'auto'],
          }}
        >
          {label}
        </div>
      ) : null}
      {buttons && buttons.length > 0 ? (
        <HStack space={2} sx={{ flex: 1 }}>
          {buttons.map((_button, _i) => {
            return (
              <Button
                key={_i}
                color={activeIndex === _i ? 'light' : 'b2'}
                sx={{ mb: 2 }}
                tier={small ? 4 : null}
                {..._button}
              />
            )
          })}
        </HStack>
      ) : null}
    </div>
  )
}

export default FlexButtons
